export enum UserType {
  individual = "individual",
  organisation = "organisation",
  none = "none",
}
